export const SmtpSettingsEditMode = {
    none: 0,
    add: 1,
    update:2
};